define('Digi.knowledge.knowledge.View'
,	[
	'digi_knowledge_knowledge.tpl'
	, 'Digi.knowledge.knowledge.SS2Model'
	, 'Backbone'
    ]
, function (
	digi_knowledge_knowledge_tpl
	, knowledgeSS2Model
	, Backbone
)
{
    'use strict';

	// @class Digi.knowledge.knowledge.View @extends Backbone.View
	return Backbone.View.extend({

		template: digi_knowledge_knowledge_tpl

	,	initialize: function (options) {

			var environment = options.container.getComponent('Environment');
			var config = environment.getConfig('digiConfigSettings.knowledge');

			this.knowledgeURL = config.url || 'http://www.digi.com';
	}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return Digi.knowledge.knowledge.View.Context
	,	getContext: function getContext()
		{
			//@class Digi.knowledge.knowledge.View.Context
			window.open(this.knowledgeURL, '_blank')
			Backbone.history.navigate('overview',{trigger:true});
			return {
			};
		}

		, getSelectedMenu: function getSelectedMenu() {
			return 'knowledge'
		}

	});

});
